import React, { useState,useRef,useEffect }  from 'react';
import {  message, Button, } from 'antd';
import { EditOutlined,PlusOutlined } from '@ant-design/icons';
import { ProTable } from '@ant-design/pro-components';
import EditModel from './components/edit';
import {api_position_list} from '../../api';
import { localStorageGet } from '../../utils/global.js';

export const waitTimePromise = async (time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export const waitTime = async (time) => {
  await waitTimePromise(time);
};

export default () => {
  const actionRef = useRef();

  const [showModal, setShowModal] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [pagination, setPagination] = useState({current:1,pageSize:10,total:0});
  const [pageSize, setPageSize] = useState(10);
  const [tenentList, setTenentList] = useState({});

  const currentUserinfo = localStorageGet('UserInfo_k');

  useEffect(() => {
  }, []);
  
  const closeModal = () =>{
    setShowModal(false);
  }

  let columns = currentUserinfo.roleid=='99'? [
    {
      title: '所属租户',
      dataIndex: 'tenant_id',
      key: 'tenant_id',
      ellipsis:true,
      width: 150,
      // search: false,
      valueType: 'select',
      valueEnum: tenentList,
    }] : [];
  columns = [...columns, ...[
    {
      title: '岗位ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      search: false,
    },
    {
      title: '岗位名称',
      dataIndex: 'name',
      key: 'name',
      ellipsis:true,
      // width: 100,
    },
    {
      title: '岗位描述',
      dataIndex: 'description',
      key: 'description',
      search: false,
      ellipsis:true,
      // width: 100,
    },
    {
      title:'添加时间',
      dataIndex: 'creat_time',
      key: 'creat_time',
      // valueType: "dateRange",
      width: 150,
      key:"creat_time",
      search: false,
    },
    {
      title: '添加用户',
      dataIndex: 'creat_username',
      key: 'creat_username',
      ellipsis:true,
      width: 100,
      search: false,
    },
    {
      title: '操作',
      valueType: 'option',
      width: 80,
      key: 'option',
      render: (text, record, _, action) => [
        <a  key={"edita"+record.tenant_id}
          onClick={async() => {
            console.log('record ------------- ', record)
            console.log('action ------------- ', action)
            // action?.startEditable?.(record.id);
            setRowInfo(record);
            await waitTime(100);
            setShowModal(true);
          }}
        >
          <EditOutlined  key={"edit"+record.tenant_id} 
            style={{backgroundColor:"rgb(24,188,156)",padding:"2px 3px",borderRadius:3,color:"white",display:currentUserinfo.id==record.creat_userid?"block":"none"}} />
        </a>,
        // record.roleid!=99 && 
        // <Popconfirm  key={"delpop"+record.tenant_id}
        //   title="确定删除吗?" onConfirm={() => {delComp(record.cid)}}>
        //   <DeleteOutlined  key={"del"+record.tenant_id}
        //     style={{backgroundColor:"#ff4d4f",padding:"2px 3px",borderRadius:3,color:"white"}} />
        // </Popconfirm>
      // <a href={record.url} target="_blank" rel="noopener noreferrer" key="view">
        //   查看
        // </a>,
        // <TableDropdown
        //   key="actionGroup"
        //   onSelect={() => action?.reload()}
        //   menus={[
        //     { key: 'copy', name: '复制' },
        //     { key: 'delete', name: '删除' },
        //   ]}
        // />,
      ],
    },
  ]];

  return (
    <div>
          
    <ProTable
      headerTitle="岗位列表"
      columns={columns}
      actionRef={actionRef}
      rowKey="id"
      cardBordered
      defaultSize="small"
      request={async (params, sort, filter) => {
        console.log(params,sort, filter);
        // await waitTime(2000);
        var tableData = [];
        var res = await api_position_list(params);
        console.log('api_position_list-res-----------------', res);
        if(res.data.code == 9){
          tableData = res.data.list;
          if(res.data.tenant_list)
            setTenentList(res.data.tenant_list);
        }else
          message.error(res.data.msg);

        return {
          data: tableData,
          // current: res.data.pageNo,
          // pageSize: res.data.pageSize,
          success: true,
          // total: res.data.totalRows,
        };
      }}
      search={{
        labelWidth: 'auto',
      }}
      options={{
        reload: false, // 去掉刷新按钮
        density: false, // 去掉密度按钮
        setting: true, // 保留列设置按钮
        setting: {
          listsHeight: 400,
        },
      }}
      style={{lineHeight: '0.40rem',marginTop:'0.32rem',overflowX: 'scroll',overflowY: 'scroll'}}  
      scroll={{x:900}}
      columnsState={{
        persistenceKey: 'pro-table-position',
        persistenceType: 'localStorage',
        onChange(value) {
          console.log('value: ', value);
        },
      }}

      // form={{
      //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
      //   syncToUrl: (values, type) => {
      //     if (type === 'get') {
      //       return {
      //         ...values,
      //         created_at: [values.startTime, values.endTime],
      //       };
      //     }
      //     return values;
      //   },
      // }}
      pagination={{
        pageSize: pageSize,
        showSizeChanger: true,
        onChange: (page,pagesize) => {
          console.log(page);
          console.log(pagesize);
          setPageSize(pagesize);
        },
      }}
      // dateFormatter="string"

      toolBarRender={() => [
        <Button
          key="button"
          icon={<PlusOutlined />}
          // style={{backgroundColor:"rgb(5,168,137)"}}
          onClick={async() => {
            setRowInfo({});
            await waitTime(100);
            setShowModal(true);
          }}
          type="primary"
          disabled={currentUserinfo.roleid=='99'?true:false}
        >
          新增岗位
        </Button>,
      ]}
    />

    <EditModel
      showModal={showModal}
      closeModal={closeModal}
      rowInfo={rowInfo}
      refreshlist={()=>{actionRef.current?.reload();}}
  />

    </div>
  );
};